export const ADMIN = "ADMIN";
export const CS = "CS";
export const SUPERADMIN = "SUPERADMIN"
